
import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';


function validateEmail(email) {
  /* eslint-disable no-useless-escape */
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
  /* eslint-enable no-useless-escape */
}

export default class AddUserForm extends React.Component {

  requiredFields = ["userName", "firstName", "lastName", "email"]

  constructor(props) {
    super(props)
    this.state = props.model

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit = () => {
    let updatedState = {};
    let foundError = false;
    this.requiredFields.forEach(f=> {
      updatedState[`${f}ValidationError`] =  !this.state[f]? 'Required' : '';
      foundError = foundError || !this.state[f];
    });

    if (!validateEmail(this.state.email) && !updatedState.emailValidationError) {
      updatedState.emailValidationError = 'Valid email address required.'
    }

    if (!foundError){
      this.props.onSubmit(this.state);
    } else {
      this.setState(updatedState);
    }

  }


  render() {

    const actions = [
      <FlatButton
        label="Cancel"
        primary={false}
        keyboardFocused={true}
        onTouchTap={this.props.onClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.onSubmit}
      />,
    ];
    return (
      <Dialog
          title='Add new user'
          actions={actions}
          modal={true}
          open={this.props.show}
          onRequestClose={this.onClose}
      >
          <TextField
            floatingLabelText="Username" 
            value={this.state.userName} 
            onChange={(e)=> this.setState({userName: e.target.value})}
            errorText={this.state.userNameValidationError}
          /><br/>
          <TextField
            floatingLabelText="Email Address"
            type="email" 
            value={this.state.email} 
            onChange={(e)=> this.setState({email: e.target.value})}
            errorText={this.state.emailValidationError}
          /><br/>

          <TextField
            floatingLabelText="First Name" 
            value={this.state.firstName} 
            onChange={(e)=> this.setState({firstName: e.target.value})}
            errorText={this.state.firstNameValidationError}
          /><br/>
          <TextField
            floatingLabelText="Last Name" 
            value={this.state.lastName} 
            onChange={(e)=> this.setState({lastName: e.target.value})}
            errorText={this.state.lastNameValidationError}
          /><br/>
      </Dialog>
    );

  }


}



// WEBPACK FOOTER //
// ./src/containers/Locations/AddUserForm.js